[
  {
    "bpnl": "BPNL0003CRHK",
    "legalName": "Tech Solutions Limited",
    "shortName": "Tech Solutions Ltd.",
    "sector": "Information Technology",
    "legalForm": "GmbH",
    "website": "https://www.techsolutions.com",
    "description": "Leading provider of innovative IT solutions and consulting services",
    "foundingDate": "2015-03-15T00:00:00Z",
    "createdDate": "2024-06-15",
    "street": "Hauptstraße",
    "houseNumber": "42",
    "postalCode": "10115",
    "city": "Berlin",
    "country": "Germany",
    "commercialRegisterNumber": "HRB 123456",
    "commercialRegisterCourt": "Berlin",
    "taxIdNumber": "DE123456789",
    "admissionState": "PENDING",
    "activityState": "INACTIVE",
    "representative": {
      "title": "Dr.",
      "firstName": "Alice",
      "lastName": "Johnson",
      "position": "CEO",
      "email": "alice.johnson@techsolutions.com",
      "phoneNumber": "+49-30-12345678",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "org-123",
    "did": "did:web:org-123.example.com"
  },
  {
    "bpnl": "BPNL0007OR16",
    "legalName": "Innovatech Corporation",
    "shortName": "Innovatech Corp.",
    "sector": "Manufacturing",
    "legalForm": "AG",
    "website": "https://www.innovatech.de",
    "description": "Innovative solutions for modern manufacturing challenges",
    "foundingDate": "2018-06-20T00:00:00Z",
    "createdDate": "2024-08-22",
    "street": "Industrieweg",
    "houseNumber": "15",
    "postalCode": "80331",
    "city": "München",
    "country": "Germany",
    "commercialRegisterNumber": "HRB 654321",
    "commercialRegisterCourt": "München",
    "taxIdNumber": "DE987654321",
    "admissionState": "PENDING",
    "activityState": "INACTIVE",
    "representative": {
      "title": "Dipl.-Ing.",
      "firstName": "Bob",
      "lastName": "Smith",
      "position": "Managing Director",
      "email": "bob.smith@innovatech.de",
      "phoneNumber": "+49-89-98765432",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "org-456",
    "did": "did:web:org-456.example.com"
  },
  {
    "bpnl": "BPNL0005RXJT",
    "legalName": "Green Energy Solutions GmbH",
    "shortName": "Green Energy",
    "sector": "Renewable Energy",
    "legalForm": "GmbH",
    "website": "https://www.greenenergy.de",
    "description": "Sustainable energy solutions for a better tomorrow",
    "foundingDate": "2020-09-10T00:00:00Z",
    "createdDate": "2024-11-03",
    "street": "Sonnenallee",
    "houseNumber": "88",
    "postalCode": "60329",
    "city": "Frankfurt",
    "country": "Germany",
    "commercialRegisterNumber": "HRB 789012",
    "commercialRegisterCourt": "Frankfurt",
    "taxIdNumber": "DE456789123",
    "admissionState": "REJECTED",
    "activityState": "INACTIVE",
    "representative": {
      "title": "Prof. Dr.",
      "firstName": "Maria",
      "lastName": "Schmidt",
      "position": "Founder & CEO",
      "email": "maria.schmidt@greenenergy.de",
      "phoneNumber": "+49-69-55567890",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "org-789",
    "did": "did:web:org-789.example.com"
  },
  {
    "bpnl": "BPNL0001DSMW",
    "legalName": "AutoTech Innovations AG",
    "shortName": "AutoTech",
    "sector": "Automotive",
    "legalForm": "AG",
    "website": "https://www.autotech-innovations.com",
    "description": "Next generation automotive technologies and smart mobility solutions",
    "foundingDate": "2019-11-05T00:00:00Z",
    "createdDate": "2025-01-10",
    "street": "Neckarstraße",
    "houseNumber": "127",
    "postalCode": "70190",
    "city": "Stuttgart",
    "country": "Germany",
    "commercialRegisterNumber": "HRB 234567",
    "commercialRegisterCourt": "Stuttgart",
    "taxIdNumber": "DE234567890",
    "activityState": "INACTIVE",
    "admissionState": "PENDING",
    "representative": {
      "title": "",
      "firstName": "Thomas",
      "lastName": "Müller",
      "position": "CTO",
      "email": "thomas.mueller@autotech.com",
      "phoneNumber": "+49-711-12345678",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "org-234",
    "did": "did:web:org-234.example.com"
  },
  {
    "bpnl": "BPNL0002BPNE",
    "legalName": "BioMed Research KG",
    "shortName": "BioMed Research",
    "sector": "Healthcare & Life Sciences",
    "legalForm": "KG",
    "website": "https://www.biomed-research.de",
    "description": "Cutting-edge biomedical research and pharmaceutical development",
    "foundingDate": "2017-04-18T00:00:00Z",
    "createdDate": "2024-03-28",
    "street": "Universitätsring",
    "houseNumber": "5",
    "postalCode": "22765",
    "city": "Hamburg",
    "country": "Germany",
    "commercialRegisterNumber": "HRB 567890",
    "commercialRegisterCourt": "Hamburg",
    "activityState": "ACTIVE",
    "taxIdNumber": "DE567890123",
    "admissionState": "APPROVED",
    "representative": {
      "title": "Dr. med.",
      "firstName": "Sarah",
      "lastName": "Weber",
      "position": "Chief Scientific Officer",
      "email": "sarah.weber@biomed-research.de",
      "phoneNumber": "+49-40-87654321",
      "roles": [
        "ORGANIZATION_REPRESENTATIVE"
      ]
    },
    "document": {
      "fileName": "registrationPreface.pdf",
      "contentType": "application/pdf",
      "data": "JVBERi0xLjQKMSAwIG9iago8PC9UeXBlIC9DYXRhbG9nCi9QYWdlcyAyIDAgUgo+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlIC9QYWdlcwovS2lkcyBbMyAwIFJdCi9Db3VudCAxCj4+CmVuZG9iagozIDAgb2JqCjw8L1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA1OTUgODQyXQovQ29udGVudHMgNSAwIFIKL1Jlc291cmNlcyA8PC9Qcm9jU2V0IFsvUERGIC9UZXh0XQovRm9udCA8PC9GMSA0IDAgUj4+Cj4+Cj4+CmVuZG9iago0IDAgb2JqCjw8L1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9OYW1lIC9GMQovQmFzZUZvbnQgL0hlbHZldGljYQovRW5jb2RpbmcgL01hY1JvbWFuRW5jb2RpbmcKPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDUzCj4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMjIwIDQwMCBUZAooRHVtbXkgUERGKSBUagpFVAplbmRzdHJlYW0KZW5kb2JqCnhyZWYKMCA2CjAwMDAwMDAwMDAgNjU1MzUgZgowMDAwMDAwMDA5IDAwMDAwIG4KMDAwMDAwMDA2MyAwMDAwMCBuCjAwMDAwMDAxMjQgMDAwMDAgbgowMDAwMDAwMjc3IDAwMDAwIG4KMDAwMDAwMDM5MiAwMDAwMCBuCnRyYWlsZXIKPDwvU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0OTUKJSVFT0YK"
    },
    "id": "org-567",
    "did": "did:web:org-567.example.com"
  }
]
